export default __webpack_public_path__ + "static/media/MapMarkerShadow.64c8b079.svg";